module.exports = __webpack_public_path__ + "img/4-3-1-1-2-preview-TU2020-e.5ad4314c.jpg";